var fails = require('../internals/fails');

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/freezing.js
// module id = 1045
// module chunks = 1